module.exports = __webpack_public_path__ + "static/media/fajer-noori-nastalique-regular.e4d3d6ce.ttf";